const getLetterDesktopElements = () => {
  const lettersElemets = {
    b: document.querySelector(".mask-svg .b"),
    dotI: document.querySelector(" .mask-svg .dot-i"),
    i: document.querySelector(".mask-svg .i"),
    g: document.querySelector(" .mask-svg .g"),
  };
  return lettersElemets;
};

const getLetterMobileElements = () => {
  const lettersElemets = {
    b: document.querySelector(".mask-svg-mobile .b"),
    dotI: document.querySelector(" .mask-svg-mobile .dot-i"),
    i: document.querySelector(".mask-svg-mobile .i"),
    g: document.querySelector(" .mask-svg-mobile .g"),
  };
  return lettersElemets;
};

const validateLetterElements = (elements) => {
  return elements.b && elements.dotI && elements.i && elements.g;
};

const setGsapLetterAnimations = (letterElement) => {
  gsap.set(letterElement.b, {
    x: -800,
  });

  gsap.set(letterElement.dotI, {
    y: -200,
  });

  gsap.set(letterElement.i, {
    y: 800,
  });

  gsap.set(letterElement.g, {
    x: 800,
  });
};

const setLettersTimeLine = (letterElement) => {
  const tl = gsap.timeline({ duration: 1 });

  tl.to(letterElement.b, { x: 0 });
  tl.to(letterElement.dotI, { y: 0 }, "i");
  tl.to(letterElement.i, { y: 0 }, "i");
  tl.to(letterElement.g, { x: 0 });
};

const videoBannerAnimationInit = () => {
  const mm = window.matchMedia("(max-width: 768px)");

  const getLetters = mm.matches
    ? getLetterMobileElements()
    : getLetterDesktopElements();

  if (validateLetterElements(getLetters)) {
    setGsapLetterAnimations(getLetters);
    setLettersTimeLine(getLetters);
  }
};

export default videoBannerAnimationInit;
